module.exports = __webpack_public_path__ + "d3d832b5966d0dae3f506f92cdcadb83.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-66.png
// module id = 139
// module chunks = 0